export default __webpack_public_path__ + "media/originality-card-video.dfab7e7b.mov";